/* eslint-disable prettier/prettier */
import mitt from "mitt";
export const eventBus = mitt();
